import { gql } from 'graphql-request';

import {
  TeamAdditionalDiscount,
  TeamAddress,
  TeamCity,
  TeamClientStatus,
  TeamCompanyCrm,
  TeamCountryId,
  TeamCreatedAt,
  TeamCurrency,
  TeamDescription,
  TeamDiscount,
  TeamEmail,
  TeamFacebook,
  TeamFirstPaymentDate,
  TeamID,
  TeamImageFile,
  TeamNdaFileUUID,
  TeamNdaFileFile,
  TeamNdaFileName,
  TeamVendorFormUUID,
  TeamVendorFormFile,
  TeamVendorFormName,
  TeamAgreementUUID,
  TeamAgreementFile,
  TeamAgreementName,
  TeamInstagram,
  TeamLastPaymentDate,
  TeamLeadCreationDate,
  TeamLinkedIn,
  TeamManualTeamStatus,
  TeamName,
  TeamNanoID,
  TeamNda,
  TeamReferer,
  TeamSaleManagerID,
  TeamSaleManagerUUID,
  TeamSaleManagerNanoID,
  TeamRealDeclineReasons,
  TeamSite,
  TeamSocialNetworks,
  TeamStateID,
  TeamStateName,
  TeamTagsTagID,
  TeamTeamType,
  TeamFilesStorages,
  TeamTwitter,
  TeamUpdatedAt,
  TeamUpsalerID,
  TeamUpsalerUUID,
  TeamUpsalerNanoID,
  TeamUserID,
  TeamUUID,
  TeamValidateOutput,
  TeamZipCode,
  TeamBusinessEmail,
  TeamMarketingSourceID,
  TeamColdSourceID,
  TeamCategoryID,
  TeamCompanyRevenueID,
  TeamNatureOfLeadID,
  TeamCompanySizeID,
  TeamLocale,
  TeamTimeZone,
  TeamTimeFormat,
  TeamDateFormat,
  TeamOperationHours,
  TeamPaymentMethodID,
  TeamSource,
  TeamRespondTime,
  TeamDeliveryTime,
  TeamHourlyRate,
  TeamRevisions,
  TeamViewPerTask,
  TeamWorkflowTypeID,
  TeamPriority,
  TeamComplexities,
  TeamScopeOfWorks,
  TeamUserFullName,
  TeamUserImageFile,
  TeamImageUUID,
  TeamUserNanoID,
  TeamOwnerUUID,
  TeamOwnerNanoID,
  TeamOwnerFullName,
  TeamOwnerID,
  TeamAccountReceivables,
  TeamDebtLimit,
  TeamDeferredPayment,
  TeamHoldRate,
  TeamTransactionFee,
  TeamProvisionForBadDebt,
  TeamProvisionForRevision,
  TeamTerms,
  TeamSubCategoriesSubCategoryID,
  TeamBlockedAt,
  TeamUserUUID,
  TeamContractorID,
  TeamContractorUUID,
  TeamContractorNanoID,
  TeamPreferredPaymentMethod,
  TeamOwnerFinanceRoleID,
  TeamOwnerFinanceRoleName,
  TeamAutoRepaymentEnabledAt,
  TeamGeneralLedgerID,
  TeamCoefficient,
  TeamOwnerPayoneerPayoutsBlocked,
  TeamDefaultTaskState,
  TeamUseLdApiAt,
  TeamInvoiceViewSettings,
  TeamUseWalmartFilterAt,
  TeamDefaultInvoiceViewSettings,
  TeamDefaultInvoiceViewSettingsAt,
  TeamPlannedDeadlineDate,
  TeamNewFinStatus,
  TeamNewFinStatusReasonTagID,
  TeamNewFinStatusReasonTagName,
  TeamFinCategoryID,
  TeamFinCategoryTagName,
  TeamFinCategoryParentFinCategoryID,
  TeamCompanyID
} from '../teamsTypes';
import {
  CompanyMql,
  CompanyRevenueAmount,
  CompanySizeAmount,
  CompanySql
} from '../../companies/companiesTypes';

export interface FetchShowTeamQueryResponse {
  id: TeamID;
  uuid: TeamUUID;
  nanoId: TeamNanoID;
  name: TeamName;
  email: TeamEmail;
  businessEmail: TeamBusinessEmail;
  createdAt: TeamCreatedAt;
  blockedAt: TeamBlockedAt;
  useLdApiAt: TeamUseLdApiAt;
  useWalmartFilterAt: TeamUseWalmartFilterAt;
  autoRepaymentEnabledAt: TeamAutoRepaymentEnabledAt;
  clientStatus: TeamClientStatus;
  countryId: TeamCountryId;
  city: TeamCity;
  companyCrm: TeamCompanyCrm;
  coldSourceId: TeamColdSourceID;
  categoryId: TeamCategoryID;
  companyId: TeamCompanyID;
  companyRevenueId: TeamCompanyRevenueID;
  companySizeId: TeamCompanySizeID;
  complexities: TeamComplexities;
  description: TeamDescription;
  defaultTaskState: TeamDefaultTaskState;
  site: TeamSite;
  stateId: TeamStateID;
  stateName: TeamStateName;
  subCategories: {
    id: TeamSubCategoriesSubCategoryID;
  }[];
  address: TeamAddress;
  facebook: TeamFacebook;
  linkedIn: TeamLinkedIn;
  twitter: TeamTwitter;
  instagram: TeamInstagram;
  socialNetworks: TeamSocialNetworks;
  manualTeamStatus: TeamManualTeamStatus;
  marketingSourceId: TeamMarketingSourceID;
  natureOfLeadId: TeamNatureOfLeadID;
  nda: TeamNda;
  firstPaymentDate: TeamFirstPaymentDate;
  lastPaymentDate: TeamLastPaymentDate;
  leadCreationDate: TeamLeadCreationDate;
  locale: TeamLocale;
  mql: CompanyMql;
  sql: CompanySql;
  timeZone: TeamTimeZone;
  timeFormat: TeamTimeFormat;
  dateFormat: TeamDateFormat;
  operationHours: TeamOperationHours;
  discount: TeamDiscount;
  additionalDiscount: TeamAdditionalDiscount;
  realDeclineReasons: TeamRealDeclineReasons;
  currency: TeamCurrency;
  teamType: TeamTeamType;
  filesStorage: TeamFilesStorages;
  referer: TeamReferer;
  paymentMethods: {
    id: TeamPaymentMethodID;
  }[];
  tags: {
    id: TeamTagsTagID;
  }[];
  image: {
    file: TeamImageFile;
  };
  ndaFile?: {
    uuid: TeamNdaFileUUID;
    file: TeamNdaFileFile;
    name: TeamNdaFileName;
  };
  vendorForm?: {
    uuid: TeamVendorFormUUID;
    file: TeamVendorFormFile;
    name: TeamVendorFormName;
  };
  agreement?: {
    uuid: TeamAgreementUUID;
    file: TeamAgreementFile;
    name: TeamAgreementName;
  };
  validateOutput: TeamValidateOutput;
  userId: TeamUserID;
  user: {
    id: TeamUserID;
    fullName: TeamUserFullName;
    nanoId: TeamUserNanoID;
    image: {
      uuid: TeamImageUUID;
      file: TeamUserImageFile;
      fileName: TeamUserImageFile;
    };
  };
  ownerId: TeamOwnerID;
  owner: {
    id: TeamOwnerID;
    uuid: TeamOwnerUUID;
    nanoId: TeamOwnerNanoID;
    fullName: TeamOwnerFullName;
    financeRoleName: TeamOwnerFinanceRoleName;
    financeRole: {
      id: TeamOwnerFinanceRoleID;
    };
    payoneerPayoutsBlocked: TeamOwnerPayoneerPayoutsBlocked;
  };
  upsalers: {
    id: TeamUpsalerID;
    uuid: TeamUpsalerUUID;
    nanoId: TeamUpsalerNanoID;
  }[];
  salesManagers: {
    id: TeamSaleManagerID;
    uuid: TeamSaleManagerUUID;
    nanoId: TeamSaleManagerNanoID;
  }[];
  scopeOfWorks: TeamScopeOfWorks;
  updatedAt: TeamUpdatedAt;
  zipCode: TeamZipCode;
  viewPerTask: TeamViewPerTask;
  revisions: TeamRevisions;
  hourlyRate: TeamHourlyRate;
  deliveryTime: TeamDeliveryTime;
  respondTime: TeamRespondTime;
  source: TeamSource;
  workflowTypeId: TeamWorkflowTypeID;
  priority: TeamPriority;
  accountReceivables: TeamAccountReceivables;
  debtLimit: TeamDebtLimit;
  deferredPayment: TeamDeferredPayment;
  holdRate: TeamHoldRate;
  transactionFee: TeamTransactionFee;
  preferredPaymentMethod: TeamPreferredPaymentMethod;
  provisionForBadDebt: TeamProvisionForBadDebt;
  provisionForRevision: TeamProvisionForRevision;
  terms: TeamTerms;
  users: {
    id: TeamUserID;
    uuid: TeamUserUUID;
    nanoId: TeamUserNanoID;
  }[];
  contractors: {
    id: TeamContractorID;
    uuid: TeamContractorUUID;
    nanoId: TeamContractorNanoID;
  }[];
  bitClientStatus: TeamClientStatus;
  bitFirstPaymentDate: TeamFirstPaymentDate;
  bitLastPaymentDate: TeamLastPaymentDate;
  generalLedgerId: TeamGeneralLedgerID;
  coefficient: TeamCoefficient;
  invoiceViewSettings: TeamInvoiceViewSettings;
  defaultInvoiceViewSettings?: TeamDefaultInvoiceViewSettings;
  defaultInvoiceViewSettingsAt?: TeamDefaultInvoiceViewSettingsAt;
  plannedDeadlineDate?: TeamPlannedDeadlineDate;
  newFinStatus?: TeamNewFinStatus;
  newFinStatusReasonTags: {
    id: TeamNewFinStatusReasonTagID;
    name: TeamNewFinStatusReasonTagName;
  }[];
  finCategory?: {
    id: TeamFinCategoryID;
    name: TeamFinCategoryTagName;
  };
  finCategories?: {
    id: TeamFinCategoryID;
    name: TeamFinCategoryTagName;
  }[];
  finSubCategories?: {
    id: TeamFinCategoryID;
    name: TeamFinCategoryTagName;
    parentFinCategoryId: TeamFinCategoryParentFinCategoryID;
  }[];
  sizeAmount?: CompanySizeAmount;
  revenueAmount?: CompanyRevenueAmount;
}

export const FETCH_SHOW_TEAM_QUERY = gql`
  query ShowTeam($uuid: ID!) {
    team(uuid: $uuid) {
      id
      uuid
      nanoId
      name
      email
      useLdApiAt
      useWalmartFilterAt
      businessEmail
      createdAt
      blockedAt
      autoRepaymentEnabledAt
      clientStatus
      countryId
      coldSourceId
      categoryId
      companyId
      companyRevenueId
      companySizeId
      sizeAmount
      revenueAmount
      complexities {
        id
      }
      city
      companyCrm
      description
      defaultTaskState
      site
      stateId
      stateName
      subCategories {
        id
      }
      address
      facebook
      linkedIn
      twitter
      instagram
      socialNetworks
      manualTeamStatus
      marketingSourceId
      natureOfLeadId
      nda
      firstPaymentDate
      lastPaymentDate
      leadCreationDate
      locale
      mql
      sql
      timeZone
      timeFormat
      dateFormat
      operationHours
      discount
      additionalDiscount
      preferredPaymentMethod
      realDeclineReasons {
        id
      }
      currency
      teamType
      filesStorage
      referer
      paymentMethods {
        id
      }
      tags {
        id
      }
      image {
        file
      }
      ndaFile {
        uuid
        file
        name
      }
      vendorForm {
        uuid
        file
        name
      }
      agreement {
        uuid
        file
        name
      }
      validateOutput
      userId
      user {
        id
        nanoId
        fullName
        image {
          uuid
          file
          fileName
        }
      }
      ownerId
      owner {
        id
        uuid
        nanoId
        fullName
        financeRoleName
        financeRole {
          id
        }
        payoneerPayoutsBlocked
        payoneerPayoutsBlockedById
      }
      upsalers {
        id
        uuid
        nanoId
      }
      salesManagers {
        id
        uuid
        nanoId
      }
      scopeOfWorks {
        id
      }
      updatedAt
      zipCode
      viewPerTask
      revisions
      hourlyRate
      deliveryTime
      respondTime
      source
      workflowTypeId
      priority
      accountReceivables
      debtLimit
      deferredPayment
      holdRate
      transactionFee
      provisionForBadDebt
      provisionForRevision
      terms
      users {
        id
        uuid
        nanoId
      }
      contractors {
        id
        uuid
        nanoId
      }
      invoiceViewSettings
      bitClientStatus
      bitFirstPaymentDate
      bitLastPaymentDate
      id
      nanoId
      uuid
      generalLedgerId
      coefficient
      defaultInvoiceViewSettings
      defaultInvoiceViewSettingsAt
      plannedDeadlineDate
      newFinStatus
      newFinStatusReasonTags {
        id
        name
      }
      finCategory {
        id
        name
      }
      finCategories {
        id
        name
      }
      finSubCategories {
        id
        name
        parentFinCategoryId
      }
    }
  }
`;
